import { translationKeys, useTranslation } from '../../../../../../services/localization';
import { useSelector } from 'react-redux';
import { selectHid } from '../../../../preferencesSelectors';
import { WarningNotification } from '../../../../../../components/Notification';
import { SubscribeToAction } from '../Actions';
import { Stack, Text } from '@atlaskit/primitives';
import React from 'react';
import { trackProductInvitationsWarningSubscribeClick } from '../../../../services/userActionEvents';

const productInvitationsKey = 'productInvitations';

const ProductInvitationsWarning = ({ onClose }: { onClose: () => void }) => {
  const { translate, keyWithTitle } = useTranslation();
  const hid = useSelector(selectHid);
  return (
    <WarningNotification
      title={translate(translationKeys.NOTIFICATION_PRODUCT_INVITATIONS_WARNING_TITLE)}
      onClose={onClose}
      actions={
        hid
          ? [
              <SubscribeToAction
                key={'subscribe-to-product-invitations'}
                hid={hid}
                subscriptionKey={productInvitationsKey}
                onSubscribeCallback={trackProductInvitationsWarningSubscribeClick}
              />,
            ]
          : undefined
      }
    >
      <Stack space='space.100'>
        <Text as='p'>
          {translate(translationKeys.NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_PRIMARY, {
            subscription: translate(keyWithTitle(productInvitationsKey)),
          })}
        </Text>
        <Text as='p'>
          {translate(translationKeys.NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_SECONDARY, {
            section: translate(keyWithTitle('product_surveys')),
          })}
        </Text>
      </Stack>
    </WarningNotification>
  );
};

export default ProductInvitationsWarning;
